module.exports = __webpack_public_path__ + "img/product23-nongmapdashuju.86f1b8c5.svg";